
import {
  getOuterNodesOfAssembleNode
} from '@/components/common/controlBar/controlBarDialog/metaComponent/utils.js'
export function washData_rowCol(walkedNode) {
  if (walkedNode.cusClass) {
      walkedNode.cusClass = walkedNode.cusClass.replaceAll('rowColOld','')
      walkedNode.cusClass = walkedNode.cusClass + ' rowColOld'
  } else if (!walkedNode.cusClass) {
    walkedNode.cusClass = 'rowColOld'
  }
}
